import {Component, Input} from '@angular/core';
import {trigger, state, style, transition, animate} from '@angular/animations';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: true,
    imports: [ProgressSpinnerModule],
    animations: [
        trigger('fade', [
            state('visible', style({opacity: 1, visibility: 'visible'})),
            state('hidden', style({opacity: 0, visibility: 'hidden'})),
            transition('visible <=> hidden', animate('400ms ease-in-out')),
        ])
    ]
})
export class LoadingComponent {
    state: 'visible' | 'hidden';

    @Input() set show(value) {
        this.state = value ? 'visible' : 'hidden';
    }

    constructor() {
        this.state = 'hidden';
    }
}
